import { AvailityServiceReviewConfiguration } from "risa-data-model";
import { modifyDataWithAddOperation } from "../../utils/procedurePaFormHelper";
import { KeyLabelElementObject } from "../../utils/procedurePaFromConstants";

// TODO Change this file into 2 small files.
export const onDeleteClick = (
  key: string,
  setKeyLabelElements: React.Dispatch<
    React.SetStateAction<KeyLabelElementObject[]>
  >,
  setConfigData: React.Dispatch<
    React.SetStateAction<AvailityServiceReviewConfiguration | undefined>
  >,
) => {
  const [baseKey, index] = key.split("_");
  const indexNumber = Number(index);

  const baseParts = {
    renderingProvidersHeading: "renderingProviders",
    diagnosesHeading: "diagnoses",
    proceduresHeading: "procedures",
  };

  const basePart = baseParts[baseKey] || baseKey;

  setKeyLabelElements((prevData) =>
    prevData.filter((item) => {
      const itemKeyParts = item.key.split("_");
      const itemIndex = Number(itemKeyParts[itemKeyParts.length - 1]);

      return !(item.key.startsWith(basePart) && itemIndex === indexNumber);
    }),
  );

  setConfigData((prev) => {
    const baseElement = prev?.elements?.[basePart];
    if (baseElement && Array.isArray(baseElement.elements)) {
      const updatedElements = [...baseElement.elements];

      // Remove the element at indexNumber + 1 if it exists
      if (indexNumber + 1 < updatedElements.length) {
        updatedElements.splice(indexNumber + 1, 1);
      }

      return {
        ...prev,
        elements: {
          ...prev.elements,
          [basePart]: {
            ...baseElement,
            elements: updatedElements,
          },
        },
      };
    }

    return prev;
  });
};

export const handleChange = (
  name: string,
  value: any,
  setKeyLabelElements: React.Dispatch<
    React.SetStateAction<KeyLabelElementObject[]>
  >,
  setConfigData: React.Dispatch<
    React.SetStateAction<AvailityServiceReviewConfiguration | undefined>
  >,
) => {
  setKeyLabelElements((prev) =>
    prev.map((item) =>
      item.key === name
        ? { ...item, element: { ...item.element, filledValue: value } }
        : item,
    ),
  );

  // TODO break function into smaller functions.
  setConfigData((prev) => {
    const hasDot = name.includes(".");
    const hasUnderscore = name.includes("_");

    if (!hasDot && !hasUnderscore) {
      return {
        ...prev,
        elements: {
          ...prev?.elements,
          [name]: {
            ...prev?.elements?.[name],
            element: {
              ...prev?.elements?.[name].elements,
              filledValue: value,
            },
          },
        },
      };
    } else if (hasDot && !hasUnderscore) {
      const [baseKey, subKey] = name.split(".");
      if (
        baseKey === "diagnoses" ||
        baseKey === "procedures" ||
        baseKey === "renderingProviders"
      ) {
        const baseElements = prev?.elements?.[baseKey].elements;
        if (Array.isArray(baseElements)) {
          return {
            ...prev,
            elements: {
              ...prev?.elements,
              [baseKey]: {
                ...prev?.elements?.[baseKey],
                elements: baseElements.map((item, index) =>
                  index === 0
                    ? {
                        ...item,
                        [subKey]: {
                          ...item[subKey],
                          filledValue: value,
                        },
                      }
                    : item,
                ),
              },
            },
          };
        }
      }
    }

    return prev;
  });
};

// TODO break function into smaller functions.
export const addAdditionalComponent = (
  key: string,
  configData: AvailityServiceReviewConfiguration | undefined,
  keyLabelElements: KeyLabelElementObject[],
  setKeyLabelElements: React.Dispatch<
    React.SetStateAction<KeyLabelElementObject[]>
  >,
  setConfigData: React.Dispatch<
    React.SetStateAction<AvailityServiceReviewConfiguration | undefined>
  >,
) => {
  if (key.includes("AddAnotherProviderAddButton")) {
    let newIndex = 0;
    if (Array.isArray(configData?.elements?.["renderingProviders"].elements)) {
      newIndex =
        configData?.elements?.["renderingProviders"]?.elements?.length ?? 0;
    }

    const elementsAfterAddOperation = modifyDataWithAddOperation(
      keyLabelElements,
      key,
      newIndex,
    );

    setKeyLabelElements([...elementsAfterAddOperation]);

    setConfigData((prev) => {
      const renderingProviders = Array.isArray(
        prev?.elements?.["renderingProviders"]?.elements,
      )
        ? prev?.elements?.["renderingProviders"]?.elements
        : [];

      if (renderingProviders && renderingProviders.length > 0) {
        const updatedrenderingProviders = [
          ...renderingProviders,
          { ...renderingProviders[0] },
        ];
        // Extract out this function
        return {
          ...prev,
          elements: {
            ...prev?.elements,
            renderingProviders: {
              ...prev?.elements?.["renderingProviders"],
              elements: updatedrenderingProviders,
            },
          },
        };
      } else {
        return prev;
      }
    });
  }
};

export const handleCheckboxChanges = (
  name: string,
  value: any,
  setKeyLabelElements: React.Dispatch<
    React.SetStateAction<KeyLabelElementObject[]>
  >,
  setConfigData: React.Dispatch<
    React.SetStateAction<AvailityServiceReviewConfiguration | undefined>
  >,
) => {};
